<template>
  <div v-if="totalFormatted || lines.length" data-test="savings-banner" class="bg-green-700 text-white p-4 space-y-2">
    <div class="flex items-start space-x-2">
      <CheckCircleIcon class="w-5 h-5 flex-shrink-0 text-white/90" />
      <div>
        <p class="text-sm font-bold leading-tight">You saved {{ totalFormatted }} on this order</p>
      </div>
    </div>
    <div v-if="lines.length" class="pl-7 space-y-1">
      <div v-for="line in lines" :key="line.label" class="flex justify-between text-xs text-white/90">
        <span>{{ line.label }}</span>
        <span>{{ line.amountFormatted }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon } from '@heroicons/vue/solid'

export default {
  name: 'OrderSummarySavingsBanner',
  components: { CheckCircleIcon },
  props: {
    totalFormatted: { type: String, default: '' },
    lines: { type: Array, default: () => [] }
  }
}
</script>
